// the design of the video selection screen in desktop mode is tightly tied to the data so the data is hardcoded in to this module
// whereas the mobile design was more reusable and could have been used with external data
import { AllDots } from "../data/map_data";

import {
  initDesktopUI,
  setTheme,
  renderDesktopItem,
} from "./desktop_ui/dot_line_utils";
interface ConnectedPeople {
  id: string;
  lineId: string;
  theme: string;
}
interface VideoItem {
  id: string;
  name: string;
  description: string;
  category: string;
  themes: string;
  video_url: string;
  video_id: string;
  duration: string;
  connectedPeople: ConnectedPeople[];
  themeIds: string[];
}

enum MainContentAction {
  loadVideo = "loadVideo",
}
interface IMainContent {
  ACTION: MainContentAction;
  state: { videoId: string };
}

const init = (
  people: VideoItem[],
  dotData: AllDots,
  thisCallback: Function
) => {
  initMobileUI(people, thisCallback);
  initDesktopUI(people, dotData, thisCallback);
};

const initMobileUI = (people: VideoItem[], thisCallback: Function) => {
  // attach callback to each video cta button
  people.forEach((person) => {
    const thisButton: HTMLElement | null = document.getElementById(
      `videoButton${person.name}`
    );
    if (thisButton !== null) {
      thisButton.addEventListener("click", (event) => {
        event.preventDefault();
        thisCallback({
          ACTION: "loadVideo",
          state: { videoId: person.video_id },
        });
      });
    }
  });
};

// called by theme callback to render both mobile and desktop
const filterContent = (selectedThemeId: string, people: VideoItem[]) => {
  setTheme(selectedThemeId);
  people.forEach((person) => {
    const isDisplayed: boolean =
      selectedThemeId === "all" || person.themeIds.includes(selectedThemeId);
    renderMobileItem(person.name, isDisplayed);
    renderDesktopItem(person.id, isDisplayed);
  });
};

const renderMobileItem = (id: string, isDisplayed: boolean) => {
  const posterCard: HTMLElement | null = document.getElementById(id);
  isDisplayed
    ? posterCard!.classList.remove("poster__list-item--disabled")
    : posterCard!.classList.add("poster__list-item--disabled");
};

export {
  init,
  filterContent,
  MainContentAction,
  IMainContent,
  VideoItem,
  ConnectedPeople,
};
